import io from 'socket.io-client';
import { environment } from '@environments';

export class Sockets {
  constructor() {
    this.collection = {};
    this.socketsParams = {};
  }

  open(name, href = '', token) {
    // console.log(this.getUrl(href));
    const socket = io(this.getUrl(href), {
      withCredentials: false,
      query: { authorization: token || localStorage.getItem('token') },
    });
    this.collection[name] = socket;

    this.socketsParams[name] = {
      count: 0,
      timeout: null,
      onConnect: this.onConnect.bind(this, name),
      onDisconnect: this.onDisconnect.bind(this, name),
    };

    socket.on('disconnect', this.socketsParams[name].onDisconnect);
    socket.on('connect', this.socketsParams[name].onConnect);
    socket.on('error', error => {
      console.log(`Socket ${name} error:`, error, socket);
    });

    socket.connect();
    return socket;
  }

  onDisconnect(name, warn) {
    console.log(`Socket ${name} disconnected:`, warn);
    console.dir(this.collection[name]);
    const socket = this.socketsParams[name];

    if (!socket.timeout) {
      if (socket.count < 30) socket.count += 5000;

      socket.timeout = setTimeout(() => {
        this.collection[name].connect();
        clearTimeout(socket.timeout);
        socket.timeout = null;
      }, socket.count * 100);
    }
  }

  onConnect(name) {
    console.log(`Socket ${name} connected`);
    this.socketsParams[name].count = 5000;
    if (this.socketsParams[name].timeout) {
      clearTimeout(this.socketsParams[name].timeout);
      this.socketsParams[name].timeout = null;
    }
  }

  close() {
    for (const socket in this.collection) {
      if (this.collection[socket]) {
        console.log(`Socket ${socket} closed`);
        this.collection[socket].off('connect', this.socketsParams[socket].onConnect);
        this.collection[socket].off('disconnect', this.socketsParams[socket].onDisconnect);

        // delete this.socketsParams[socket];
        this.collection[socket].close();
        // delete this.collection[socket];
      }
    }
  }

  getUrl(path) {
    let url = environment.VUE_APP_WEBRTC_URL;
    if (url[url.length - 1] === '/') url = url.slice(0, url.length - 1);

    if (path && path[0] !== '/') path = `/${path}`;

    return url + path;
  }
}
